import { render, staticRenderFns } from "./WorkshopsAll.vue?vue&type=template&id=07435533&scoped=true&"
import script from "./WorkshopsAll.vue?vue&type=script&lang=ts&"
export * from "./WorkshopsAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07435533",
  null
  
)

export default component.exports